import { Controller, Control } from "react-hook-form";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  LocalizationProvider,
  DesktopDatePicker,
  DesktopDatePickerProps,
} from "@mui/x-date-pickers";
import LabelInput from "../UI/LabelInput";
import { formatDate } from "../../utils/Date";

type ExtendedDatePickerProps = DesktopDatePickerProps<Date> & {
  name: string;
  control: Control<any>;
  required?: boolean;
  viewMode?: boolean | null;
  viewModeNoLabel?: boolean | null;
  placeholder?: string;
};

const ControlledDatePicker = ({
  name,
  control,
  label,
  disabled,
  disablePast,
  required,
  viewMode,
  viewModeNoLabel,
  placeholder,
  minDate,
}: ExtendedDatePickerProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
        <>
          {viewMode ? (
            <LabelInput
              label={!viewModeNoLabel && label}
              value={value ? formatDate(value) : ""}
            />
          ) : (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopDatePicker
                format="DD/MM/YYYY"
                label={label}
                onChange={onChange}
                value={value}
                ref={ref}
                disablePast={disablePast}
                disabled={disabled}
                slotProps={{
                  textField: {
                    required: required,
                    fullWidth: true,
                    size: "small",
                    error: !!error,
                    helperText: error?.message,
                    placeholder: placeholder,
                  },
                }}
                minDate={minDate}
              />
            </LocalizationProvider>
          )}
        </>
      )}
    />
  );
};

export default ControlledDatePicker;
